import React from 'react';
import styled from 'styled-components';
import I10n from '../features/i10n';
import Configuration from '../models/Configuration';
import PropTypes, { shape } from 'prop-types';
import SoftwareAccessorySelector from './software_accessory_selector';
import MsxIcons from '../features/msx-icons';
import NewBom from './bill_of_materials_rework';

const OptionsSection = styled.section`
  flex: 1 1 auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  border-top: 1px solid #e7e7e7;
  @media (max-width: 800px) {
    display: none;
  }
`;

const MobileOptionsSection = styled.section`
  flex: 1 1 auto;
  display: none;
  flex-direction: column;
  @media (max-width: 800px) {
    display: flex;
  }
`;

const NavigationTab = styled.nav`
`;
const NavigationTabItem = styled.span`
  line-height: 36px;
  font-size: 20px;
  font-weight: bold;
  color: #626469 !important;
`;

const TabContent = styled.div`
  padding-top: 10px;
`;

const SoftwareSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1 1 auto;

  min-width: 300px;
`;

const BOMSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1.5 1 0px;
  margin-left: 10px;
  @media (max-width: 800px) {
    margin-left: 0px;
    flex: auto;
  }
`;

const MobileSoftwareSection = styled.div`
`;

const MobileSoftwareHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 10px 10px 0px;
  border-top: 1px solid #e7e6e6;
  border-bottom: 1px solid #e7e6e6;
  cursor: pointer;
`;

const MobileSoftwareContent = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  overflow: hidden;
  ${props => props.isMobileOpen ? 'max-height: 5000px;' : 'max-height: 0px;'}
  transition: max-height 0.3s;
`;

const MobileSoftwarePadding = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 0px;
  padding: 10px 0px;
`;

const MobileIconWrapper = styled.div`
  transition: transform 0.3s;
  transform: ${props => props.isMobileOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
  width: 32px;
  height: 32px;
  box-sizing: content-box;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const MobileSoftwareTitle = styled.span`
  font-size: 20px;
  font-weight: bold;
  color: #626469;
`;

class ConfigurationEditorOptionsSection extends React.Component {

  static propTypes = {
    configuration: shape(Configuration).isRequired,
    preferredProductReference: PropTypes.string,
    datasheetTemplate: PropTypes.string,
    isLoadingConfiguration: PropTypes.bool,
    isLoadingCompatibleModules: PropTypes.bool,
    softwareList: PropTypes.array,
    isLoadingSoftwares: PropTypes.bool,
    changeSoftwareAccessories: PropTypes.func,
    switchIsland: PropTypes.func,
    isWorkspaceAvailable: PropTypes.bool,
    unifiedCheckoutAvailable: PropTypes.bool,
    onAddToFavorites: PropTypes.func,
    favoritesDisabled: PropTypes.bool
  }

  constructor(props) {
    super(props);
    this.state = {
      isMobileOpen: false
    }
  }

  renderBOM = () => {
    return (<BOMSection>
      <NewBom
        configuration={this.props.configuration}
        references={this.props.configuration.extractReferencesForBOM().extractSortedReferences()}
        islands={this.props.configuration.extractReferencesByIsland(false)}
        configurationName={this.props.configuration.name}
        preferredProductReference={this.props.preferredProductReference}
        switchIsland={this.props.switchIsland}
        isLoading={this.props.isLoadingConfiguration || this.props.isLoadingCompatibleModules}
        isWorkspaceAvailable={this.props.isWorkspaceAvailable}
        unifiedCheckoutAvailable={this.props.unifiedCheckoutAvailable}
        onAddToFavorites={this.props.onAddToFavorites}
        favoritesDisabled={this.props.favoritesDisabled}
        allowBOMFavorites={false}
        showAvailabilityStatus={false}
      ></NewBom>
    </BOMSection>);
  }


  render = () => {
    return (
      <>
        <OptionsSection>
          <SoftwareSection>
            <NavigationTab>
              <NavigationTabItem>
                {I10n.get('screen.config_editor.software')}
              </NavigationTabItem>
            </NavigationTab>
            <TabContent>
              <SoftwareAccessorySelector
                selectedSoftwareList={this.props.configuration.accessories.softwareList}
                softwareList={this.props.softwareList}
                isLoadingConfiguration={this.props.isLoadingConfiguration}
                isLoadingSoftwares={this.props.isLoadingSoftwares}
                onSoftwareUpdate={this.props.onSoftwareUpdate}
              >
              </SoftwareAccessorySelector>
            </TabContent>
          </SoftwareSection>
          {this.renderBOM()}
        </OptionsSection>
        <MobileOptionsSection>
          <MobileSoftwareSection isMobileOpen={this.state.isMobileOpen}>
            <MobileSoftwareHeader onClick={() => { this.setState({ isMobileOpen: !this.state.isMobileOpen }) }}>
              <MobileSoftwareTitle>
                {I10n.get('screen.config_editor.software')}
              </MobileSoftwareTitle>
              <MobileIconWrapper isMobileOpen={this.state.isMobileOpen}>
                <MsxIcons name="down-arrow" size="small"></MsxIcons>
              </MobileIconWrapper>
            </MobileSoftwareHeader>
            <MobileSoftwareContent isMobileOpen={this.state.isMobileOpen}>
              <MobileSoftwarePadding>
                <SoftwareAccessorySelector
                  selectedSoftwareList={this.props.configuration.accessories.softwareList}
                  softwareList={this.props.softwareList}
                  isLoadingConfiguration={this.props.isLoadingConfiguration}
                  isLoadingSoftwares={this.props.isLoadingSoftwares}
                  onSoftwareUpdate={this.props.onSoftwareUpdate}
                >
                </SoftwareAccessorySelector>
              </MobileSoftwarePadding>
            </MobileSoftwareContent>
          </MobileSoftwareSection>
          {this.renderBOM()}
        </MobileOptionsSection>
      </>
    );
  }
}

export default ConfigurationEditorOptionsSection;
